<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Youtube">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Youtube" clip-path="url(#clip-Youtube)">
            <g id="Groupe_3177" data-name="Groupe 3177" transform="translate(-307.685 -283.762)">
                <g id="Groupe_3140" data-name="Groupe 3140" transform="translate(319.311 298.58)">
                    <path id="Tracé_3520" data-name="Tracé 3520" d="M346.5,301.634a3.489,3.489,0,0,0-2.456-2.47c-2.165-.584-10.847-.584-10.847-.584s-8.682,0-10.847.584a3.489,3.489,0,0,0-2.455,2.47,39.314,39.314,0,0,0,0,13.452,3.492,3.492,0,0,0,2.455,2.471c2.166.583,10.847.583,10.847.583s8.683,0,10.847-.583a3.492,3.492,0,0,0,2.456-2.471,39.306,39.306,0,0,0,0-13.452Z" transform="translate(-319.311 -298.58)" fill="none" :stroke="color" stroke-width="2"/>
                    <path id="Tracé_3521" data-name="Tracé 3521" d="M331.426,313.038v-8.256l7.256,4.128Z" transform="translate(-320.384 -299.129)" fill="none" :stroke="color" stroke-width="2"/>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconYoutubeOutline',
    mixins: [Colorable],
};
</script>
